import { render, staticRenderFns } from "./DownloadIcon.vue?vue&type=template&id=fa5f5578"
import script from "./DownloadIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadIcon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports